<template>
  <div>

    <breadcrumbs />

    <loading :active.sync="isLoading"></loading>

    <div class="content-i">
      <div class="content-box">
        <div class="row">
          <div class="col-sm-12">
            <!--START - User List -->
            <div class="element-wrapper">
              <h6 class="element-header capitalize">
                {{ t.navigation.providers }}
              </h6>
              <div class="element-box-tp" v-if="providers">
                  <table class="table table-bordered table-lg table-v2 table-striped">
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Name</th>
                        <th>Profit Share</th>
                        <th>Net Profit</th>
                        <th>Is Active</th>
                      </tr>
                    </thead>
                    <tbody>
                    <tr v-for="p in providers">
                      <td width="90"># {{ p.id }}</td>
                      <td><router-link :to="{query: {id: p.id}}">{{ p.name }}</router-link></td>
                      <td width="20" v-tooltip="t.profit_share">%{{ (p.profit_share * 100)  }}</td>
                      <td width="20" v-tooltip="t.profit_share">%{{ (p.net_profit * 100) }}</td>
                      <td width="20">
                        <div id="toggles" class="pull-right" v-tooltip="'is Active'">
                          <input type="checkbox" class="ios-toggle" :id="'is'+p.id" v-model="p.is_active" @change="setProviderStatus(p.id, p.is_active)" />
                          <label :for="'is'+p.id"  class="checkbox-label"></label>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--------------------
START - Sidebar
-------------------->
      <div class="content-panel compact">
        <div class="content-panel-close" v-on:click="controlPanel()">
          <i class="os-icon os-icon-close"></i>
        </div>
        <div class="element-wrapper">
          <div class="element-actions actions-only" v-b-toggle.filter variant="primary">
							<span class="when-opened">
								<i class="os-icon os-icon-minus-circle"></i>
							</span>
            <span class="when-closed">
								<i class="os-icon os-icon-plus-circle"></i>
							</span>
          </div>
          <h6 class="element-header" v-b-toggle.filter variant="primary">
            {{ t.filter.title }}
          </h6>
          <div class="element-box-tp">
            <b-collapse id="filter" visible class="mt-2">

            </b-collapse>
          </div>
        </div>

      </div>
      <!--------------------
      END - Sidebar
      -------------------->
    </div>

    <sweet-modal ref="umodal" @close="clearId">
      <ProviderForm :id="$route.query.id" />
    </sweet-modal>
  </div>
</template>

<script>

  import ProviderForm from '@/components/casino/form/provider'
  import casino from '@/mixins/casino'
  export default {
    name: 'ProviderList',
    mixins: [casino],
    components: {ProviderForm},
    data () {
      return {
        t: this.$root.t,
        providers: null,
        isLoading: false
      }
    },
    mounted () {
      this.getProviders().then(response => {
        this.providers = response.body.result;
      })
    },
    watch: {
      '$route'() {

        this.getProviders().then(response => {
          this.providers = response.body.result;
        })

        if (this.$route.query.id > 0)
          this.$refs.umodal.open();
      },
    },
    methods: {
      clearId () {
        this.$router.push({ query: null });
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/casino/ProviderList.vue